(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contractor-directory"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".contractor-directory__search").forEach((input) => {
  const list = document.getElementById(input.getAttribute("aria-controls"));
  if (!list) return;
  const links = Array.from(list.querySelectorAll("a"));
  const status = input.parentElement.querySelector(".contractor-directory__search-status");
  input.addEventListener("input", () => {
    const term = input.value.trim().toLocaleLowerCase();
    let count = 0;
    links.forEach((link) => {
      const matches = link.textContent.toLocaleLowerCase().includes(term);
      link.hidden = !matches;
      if (matches) count++;
    });
    status.textContent = count ? `${count} states and territories match.` : "No states or territories match. Try another name.";
    status.classList.toggle("visually-hidden", count > 0);
  });
});
  } catch(e) { console.error(e); }
})();

})();
